module.exports = __webpack_public_path__ + "img/playT.36599bfb.svg";